<template>
    <div style="display: flex; flex-direction: column; align-items: center;">
        <h1>Has Any No Permission!</h1>
        <div>
            <a href="javascript:void(0)" @click="userManager.logout()">Logout</a>
        </div>
    </div>
</template>

<script>
    /**
     * 로그인 후 어떠한 권한도 없을때 나타나는 페이지입니다.
     */
    export default {
        name: "HasAnyNoPermission",
        methods: {
        }
    }
</script>

<style scoped>

</style>